import React, {useState, useEffect} from 'react';
import Link from "next/link";
import styled from "styled-components";
import {getDistrict} from "@models/district";
import {getProperties} from "@models/search";
import LandingAreasSliderWithoutImg from "@organisms/property/landing/landing_areas_slider_without_img";
import LandingTile from "@organisms/property/landing/tiles";
import LandingProperties from "@organisms/property/landing/properties";
import BrandingText from "@molecules/widgets/branding_text";
import InvestmentBannerGridWithLottie from "@molecules/banners/investment_banner_grid_with_lottie";
import {isEmpty} from "@helpers/helpers";
import Icon from "@atoms/icon";
import Coin2Icon from '@icons/coin2.svg';
import Coin3Icon from '@icons/coin3.svg';
import Coin4Icon from '@icons/coin4.svg';
import ApartmentIcon from '@icons/apartment.svg';

const HolyShrine = ({city_id, pageTitle, cityPropertiesWidget, handleBackFromLanding, prominentRealtorsLists, specialCitiesLists}) => {
    const [properties, setProperties] = useState(cityPropertiesWidget ?? []);
    const [district, setDistrict] = useState(null);
    const districtId = 2759;

    useEffect(() => {
        const propertiesParams = {
            city_id: 207,
            district_id: [districtId],
            types: ['apartment'],
            deal_type: 'sale',
            sort: 'boosted_at',
            has_media: 1,
            exclude_archived: 1,
            count: 8
        };

        getProperties(1, null, propertiesParams).then(result => {
            setProperties(result.properties);
        });

        getDistrict(districtId).then(result => {
            setDistrict(result)
        })
    }, [city_id]);


    const priceTileItems = [
        {title: 'تا 1٫5 میلیارد', href: '/properties', hrefAs: '/املاک-مشهد/خرید-فروش-آپارتمان/نزدیک-حرم-امام-رضا/قیمت-تا-1.500-میلیارد', icon: <Coin2Icon/>},
        {title: '1٫5 تا 3 میلیارد', href: '/properties', hrefAs: '/املاک-مشهد/خرید-فروش-آپارتمان/نزدیک-حرم-امام-رضا/قیمت-1.500-تا-3-میلیارد', icon: <Coin3Icon/>},
        {title: '3 تا 5 میلیارد', href: '/properties', hrefAs: '/املاک-مشهد/خرید-فروش-آپارتمان/نزدیک-حرم-امام-رضا/قیمت-3-تا-5-میلیارد', icon: <Coin4Icon/>},
    ];

    const areaTileItems = [
        {title: 'تا 75 متر', href: '/properties', hrefAs: '/املاک-مشهد/خرید-فروش-آپارتمان/نزدیک-حرم-امام-رضا/زیربنا-تا-75-متر', icon: <ApartmentIcon/>},
        {title: '75 تا 100 متر', href: '/properties', hrefAs: '/املاک-مشهد/خرید-فروش-آپارتمان/نزدیک-حرم-امام-رضا/زیربنا-75-تا-100-متر', icon: <ApartmentIcon/>},
        {title: 'بیش از 100 متر', href: '/properties', hrefAs: '/املاک-مشهد/خرید-فروش-آپارتمان/نزدیک-حرم-امام-رضا/زیربنا-100-متر-به-بالا', icon: <ApartmentIcon/>},
    ];

    const specialDistricts = [
        {name: 'خیابان امام رضا', url: '/املاک-مشهد/خرید-فروش-آپارتمان/امام-رضا-(-خیابان-تهران-)'},
        {name: 'خیابان طبرسی', url: '/املاک-مشهد/خرید-فروش-آپارتمان/طبرسی-(بلوار-اول)'},
        {name: 'خیابان نواب صفوی', url: '/املاک-مشهد/خرید-فروش-آپارتمان/نواب-صفوی'},
        {name: 'خیابان شیرازی', url: '/املاک-مشهد/خرید-فروش-آپارتمان/خیابان-شیرازی'},
    ];

    const LandingAreasSliderBreakpoints = {
        1024: {
            slidesPerView: 4,
        },
        768: {
            slidesPerView: 2.6,
        },
        365: {
            slidesPerView: 1.5,
        },
        320: {
            slidesPerView: 1.2,
        }
    };

    return (
        <Container className={'landing-page-container '}>

            <section className="mt-16 mt-lg-56">
                <div className="container">
                    <h1 className="mb-16">{pageTitle ?? `خرید فروش آپارتمان نزدیک حرم امام رضا`}</h1>
                </div>

                <div className="container">
                    <InvestmentBannerGridWithLottie
                        propertyTypes={['apartment']}
                        propertyDealType={'sale'}
                        districts={(!isEmpty(district) ? [district] : [])}
                        city_id={207}
                        isBadeSaba={false}
                        addParamsToUrl={`?district_id=` + districtId}
                        investmentPhoneNumber="09150303080"
                    />
                </div>
            </section>

            <Sections className="container sm-fluid">
                <LandingAreasSliderWithoutImg
                    city_id={207}
                    items={specialDistricts}
                    breakpoints={LandingAreasSliderBreakpoints}
                    propertyType="آپارتمان"
                    showOtherAreas={false}
                />
            </Sections>

            <Sections className="container mt-40 mt-lg-56">
                <h2 className="mb-16">بر اساس قیمت آپارتمان</h2>
                <LandingTile iconsClassName="price" items={priceTileItems} iconSize={32}/>
            </Sections>

            <Sections className="container">
                <h2 className="mb-16">بر اساس متراژ</h2>

                <LandingTile className="apartment" items={areaTileItems}/>
            </Sections>

            <Sections>
                <div className="container">
                    <h2 className="mb-16">جدیدترین آپارتمان‌های نزدیک حرم امام رضا </h2>
                </div>

                <div className="container sm-fluid">
                    <LandingProperties city_id={207} properties={properties}/>
                </div>
            </Sections>

            <Sections className={"container "}>
                <BrandingText/>
            </Sections>

            <div className="mt-56"/>
        </Container>
    );
};

export default React.memo(HolyShrine);

// styles
const Container = styled.div`

    &.search-navbar-fixed {
       margin-top: 120px !important;
       
       @media (max-width: ${props => props.theme.screenXsMax}) {
          margin-top: 0 !important;
       }
   }
`;

const Sections = styled.section`
    margin-top: 80px;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        margin-top: 64px;
        
        &.xs-bottom-swiper {
            margin-top: 40px;
        }
    }
    
    img {
        background-color: ${props => props.theme.gray100};
    }
`;


